import { render, staticRenderFns } from "./remarks.vue?vue&type=template&id=01882a21"
import script from "./remarks.vue?vue&type=script&lang=js"
export * from "./remarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports